import React, { useState } from "react";
import { Button, Checkbox } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import TopTitleFormComponent from "./TopTitleFormComponent";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadString,
} from "firebase/storage";
import { updateDoc, doc as firestoreDoc } from "firebase/firestore";
import { showCustomToast } from "../Misc/CustomToast";
import SignaturePadComponentV2 from "../Signature/SignaturePadComponentV2";
import DatePickerComponent from "../DatePickerComponent";
import TextField from "@mui/material/TextField";
import { StandardDrawerFooter } from "./StandardDrawer";
import "./AdmissionDocumentRedesign.css";

function AddConsentAgreementUnsupervisedActivityGood(props) {
  const [isLoading, setIsLoading] = useState(false);
  const { clientId } = props;
  const [checked1, setChecked1] = useState(false);
  const [signatureDataURL, setSignatureDataURL] = useState(null);
  const [, setIsSignatureStarted] = useState(false);
  const [outingDate, setOutingDate] = useState(null);
  const [outingLocation, setOutingLocation] = useState("");
  const [outingPurpose, setOutingPurpose] = useState("");

  const consentIntro =
    "This consent form outlines the client's responsibilities when attending any unaccompanied off-site activities, and the potential consequences of non-compliance. By signing, the client acknowledges understanding and agreement to these terms as part of their therapeutic process.";

  const responsibilities =
    "Responsibilities:\n\nAdherence to Schedule:\n- Return to Miracles Asia main site by the agreed-upon time.\n- Attend all scheduled unsupervised appointments on-time and leave to return to Miracles Asia site immediately following the conclusion of the appointment.\n- No additional activities are permitted during this scheduled off-site time.\n\nBehavioural Expectations:\n- Maintain sobriety and always abstain from substances, at all times.\n- Uphold the Miracles Asia’s standards of conduct and respect community norms.\n\nHealth and Safety:\n- Follow all personal safety guidelines provided by staff at Miracles Asia.\n- Inform the staff at Miracles Asia of any changes in health status or emergencies immediately.\n\nCommunication:\n- Maintain regular contact with designated Miracles Asia staff as arranged prior to departure.\n- Report back any significant experiences, feelings, or concerns encountered during the off-site activity.";

  const consequences =
    "Consequences of Non-compliance:\n\nReview of Privileges:\n- Removal or suspension of all off-site and self-outing privileges pending a review.\n\nAdditional Treatment Protocols:\n- Possible requirement to participate in additional therapeutic interventions or sessions.\n\nReferral to Treatment Team:\n- Detailed discussion with the treatment team to reassess the current treatment plan.\n\nDocumentation:\n- Incidents of non-compliance will be documented and may affect future considerations for off-site and self-outing or other privileges within the program.";

  const acknowledgment =
    "Acknowledgment:\n\nI acknowledge that I have read and understand the terms and conditions of the self-outing privileges as detailed above. I agree to adhere to these responsibilities for the benefit of my recovery journey and accept the outlined consequences should I fail to meet these expectations.";

  const [isSignatureValidated, setIsSignatureValidated] = useState(false);

  const handleSignatureSave = (dataURL) => {
    setSignatureDataURL(dataURL);
  };

  const handleCheckboxChange1 = (event) => {
    setChecked1(event.target.checked);
  };

  const uploadSignature = async () => {
    const storage = getStorage();
    const fileName = `${clientId}.png`;
    const signatureRef = ref(
      storage,
      `MandatoryForms/ConsentAgreementUnsupervisedActivity/${fileName}`
    ); // Modifiez cette ligne

    await uploadString(signatureRef, signatureDataURL, "data_url");
    const downloadURL = await getDownloadURL(signatureRef);

    return downloadURL;
  };

  const handleFormSubmit = async () => {
    if (!checked1 || !signatureDataURL || !isSignatureValidated) {
      showCustomToast(
        "Please agree to all the terms before submitting.",
        "error"
      );
    }

    try {
      setIsLoading(true);
      const signatureURL = await uploadSignature();

      // AJOUT dans la sous-collection du client
      await addDoc(
        collection(
          db,
          "clients",
          clientId,
          "ConsentAgreementUnsupervisedActivities"
        ),
        {
          checked1,
          consentIntro,
          responsibilities,
          consequences,
          acknowledgment,
          signatureURL,
          signedOn: serverTimestamp(),
          outingDate,
          outingLocation,
          outingPurpose,
          createdAt: serverTimestamp(),
        }
      );

      const clientDocRef = firestoreDoc(db, "clients", clientId);
      await updateDoc(clientDocRef, {
        ConsentAgreementUnsupervisedActivitiesOk: true,
        ConsentAgreementUnsupervisedActivitiesOkSigned: serverTimestamp(),
      });

      showCustomToast(
        "CONSENT AND AGREEMENT FOR UNSUPERVISED OFF-STE ACTIVITIES form correctly submitted!",
        "success"
      );

      setIsLoading(false);
      props.closemodal();
    } catch (e) {
      showCustomToast("Error adding document", "error");
      setIsLoading(false);

      console.error("Error adding document: ", e);
    }
  };

  const clientDisplayName =
    [props.firstName, props.lastName].filter(Boolean).join(" ") ||
    props.clientName ||
    "Client";

  return (
    <>
      <div className="admission-document-shell admission-card-form-shell consent-agreement-form-shell">
        <TopTitleFormComponent
          title="Consent and Agreement for Unsupervised Off-Site Activities"
          eyebrow="ADMISSION FORM"
          subtitle={clientDisplayName}
          closemodal={props.closemodal}
        />

        <div className="admission-document-body consent-agreement-form-body">
          <div className="text-block" style={{ whiteSpace: "pre-line" }}>
            {consentIntro}
          </div>

          <div
            className="text-block"
            style={{ whiteSpace: "pre-line", marginTop: "10px" }}
          >
            {responsibilities}
          </div>

          <div
            className="text-block"
            style={{ whiteSpace: "pre-line", marginTop: "10px" }}
          >
            {consequences}
          </div>

          <div
            className="text-block"
            style={{ whiteSpace: "pre-line", marginTop: "20px" }}
          >
            {acknowledgment}
          </div>

          <div className="checkbox-container-margin">
            <Checkbox checked={checked1} onChange={handleCheckboxChange1} />I
            fully understand and agree to the above terms.
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              // justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              alignSelf: "center",
              paddingLeft: "10px",
            }}
          >
            <div style={{ marginTop: "10px", width: "30%" }}>
              <DatePickerComponent
                title="Date of Outing"
                value={outingDate}
                onChange={setOutingDate}
              />
            </div>
            <div
              style={{
                marginTop: "10px",
                width: "30%",
                paddingLeft: "10px",
                paddingTop: "25px",
              }}
            >
              <TextField
                label="Location (where they are going)"
                value={outingLocation}
                onChange={(e) => setOutingLocation(e.target.value)}
                fullWidth
              />
            </div>
            <div
              style={{
                marginTop: "10px",
                width: "30%",
                paddingLeft: "10px",
                paddingTop: "25px",
              }}
            >
              <TextField
                label="Purpose (e.g., family reconnection, medical appointment)"
                value={outingPurpose}
                onChange={(e) => setOutingPurpose(e.target.value)}
                fullWidth
              />
            </div>
          </div>

          <div
            style={{ width: "100%", marginBottom: "25px", marginTop: "20px" }}
          >
            <SignaturePadComponentV2
              onSignatureSave={handleSignatureSave}
              signatureDataURL={signatureDataURL}
              onSignatureStart={() => setIsSignatureStarted(true)}
              onSignatureValidate={setIsSignatureValidated}
            />
          </div>
        </div>
        <StandardDrawerFooter className="admission-document-footer">
          <div>
            <Button
              variant="contained"
              style={{ backgroundColor: "white", color: "black" }}
              // disabled={!(pic1Url && pic2Url && pic3Url && pic4Url && pic5Url)}
              onClick={props.closemodal}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleFormSubmit}
              style={
                isLoading
                  ? {
                      backgroundColor: "red",
                      color: "white",
                      marginLeft: "15px",
                    }
                  : !signatureDataURL || !isSignatureValidated || !checked1
                  ? {
                      backgroundColor: "grey",
                      color: "white",
                      marginLeft: "15px",
                    }
                  : {
                      backgroundColor: "#1565C0",
                      color: "white",
                      marginLeft: "15px",
                    }
              }
              disabled={
                isLoading ||
                !signatureDataURL ||
                !isSignatureValidated ||
                !checked1
              }
            >
              {isLoading ? "SAVING..." : "SAVE"}
            </Button>
          </div>
        </StandardDrawerFooter>
      </div>
    </>
  );
}

export default AddConsentAgreementUnsupervisedActivityGood;
